const WalletIcon = ({ ...props }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M13.3328 4.66667V3.33333C13.3328 2.598 12.7348 2 11.9995 2H3.33281C2.23014 2 1.33281 2.89733 1.33281 4V12C1.33281 13.4673 2.52881 14 3.33281 14H13.3328C14.0681 14 14.6661 13.402 14.6661 12.6667V6C14.6661 5.26467 14.0681 4.66667 13.3328 4.66667ZM11.9995 10.6667H10.6661V8H11.9995V10.6667ZM3.33281 4.66667C3.16116 4.65899 2.99908 4.5854 2.88033 4.46121C2.76157 4.33703 2.6953 4.17182 2.6953 4C2.6953 3.82818 2.76157 3.66297 2.88033 3.53879C2.99908 3.4146 3.16116 3.34101 3.33281 3.33333H11.9995V4.66667H3.33281Z"
                fill="#8C8594"
            />
        </svg>
    )
}
export default WalletIcon
